class AdvertorialFAQ extends HTMLElement {
  constructor() {
    super(),
      (this.accordions = document.querySelectorAll(
        ".page--advertorial--questions__item"
      )),
      this.bindEvents();
  }
  bindEvents() {
    this.accordions.forEach((e) =>
      e.addEventListener("click", this.toggleAccordion.bind(this))
    );
  }
  toggleAccordion(e) {
    e.currentTarget.classList.toggle(
      "page--advertorial--questions__item--active"
    );
  }
}
customElements.define("advertorial-faq", AdvertorialFAQ);